import React, { useState } from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    formataValor,
    formataPrimeiraReuniaoLabelValor,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem1,
    GridItem1xs2,
    GridItem2,
    GridItem2xs4,
    GridItem3,
    GridItem4,
    //GridItem4xs6,
    GridItem5xs6,
    GridItem5xs10,
    GridItem6,
    GridItem6sm12xs12,
    GridItem6xs12,
    GridItem8,
    GridItem9,
    GridItem10xs11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    SvgIconDiaDia,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    SvgIconReceitaMensal,
    SvgIconPatrimonioImobilizado,
    SvgIconRecursosFinanceiros,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    LinkPadraoNoSubmit,
} from '../../../business-components/Link/Link'

import percentualList from '../../../business-rules/List/percentualList'

import AnalisePatrimonialPieChart from '../estudo-chart/AnalisePatrimonialPieChart'

import {
    TaxaCDIAnual,
    RetornoCDI,
    TaxaJurosAnual,
    TipoMomentoTributacaoIR,
    PercIR,
    TempoMinimoEntreAportesResgatesCalculoIRAnos,
    TaxaInflacaoAnual,
    TaxaRetornoAnualReal,
    ExibirEvolucaoAporteMensalInflacao,
    ExibirEvolucaoRetiradaMensalInflacao,
    ExibirEvolucaoRecursosFinanceirosFinalInflacao,
    DiferenciarTaxasAposAposentadoria,
    TaxaCDIAnualAposAposentadoria,
    RetornoCDIAposAposentadoria,
    TaxaJurosAnualAposAposentadoria,
    TaxaInflacaoAnualAposAposentadoria,
    TaxaRetornoAnualRealAposAposentadoria,
} from '../estudo-parametros/EstudoCompTaxas'

//import {
//    RetornoFinanceiroRadioGroup
//} from '../../../business-rules/RadioGroup/RetornoFinanceiroRadioGroup'

import {
    calculaValorPremioAnualizadoVidaInteira,
    calculaValorCSVidaInteira,
} from '../estudo-form/EstudoServiceGarantiasRecursosFinanceiros'

import {
    processaValoresDefaultIniciaisCenariosTaxas,
} from '../estudo-parametros/EstudoServiceCenariosTaxas'

import {
    processaValoresDefaultIniciaisClienteConjuge,
} from '../estudo-parametros/EstudoServiceClienteConjuge'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    CustomizedDialogsPopupPatrimonioImobilizado,
    CustomizedDialogsPopupRecursosFinanceiros,
    CustomizedDialogsPopupSucessaoVitalicia,
    CustomizedDialogsPopupParametrosGestaoPatrimonial,
    AposentadoriaExpectativaVidaCliente,
    AposentadoriaExpectativaVidaClienteConjuge,
    CustomizedDialogsPopupReceitaMensal,
    CustomizedDialogsPopupDespesas,
    CustomizedDialogsPopupCapacidadePoupanca,
} from './SimulacaoFinanceiraCompParametros'

import GestaoPatrimonialFormResumoPatrimonialTotalAtivos from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonialTotalAtivos'



const SimulacaoFinanceiraFormParametros = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, vars, popup/*, reexibir,
        setReexibir*/ }) => {

    processaValoresDefaultIniciaisCenariosTaxas(values)
    
    processaValoresDefaultIniciaisClienteConjuge(values)

    const valorPremioAnualizadoVidaInteira = calculaValorPremioAnualizadoVidaInteira(values)



    const [refresh, setRefresh] = useState(true)

    const [expandiu, setExpandiu] = useState(false)

    const GridItemParametros = popup ? GridItem12 : GridItem6sm12xs12

    const isXsDownScreen = IsXsDownScreen()

    const report = false



    return (
        (refresh || !refresh) && (
            <GridItemParametros>
                <CardGridEntradaDados>
                    <CardGridEntradaDadosHeaderBody
                        title={LABEL.ativos}
                    >
                        <GridContainer>
                            <GridItem5xs10>
                                <GridContainer>
                                    <GridItem3
                                        align='right'
                                    >
                                        <SvgIconPatrimonioImobilizado
                                            fontSize='large'
                                        />
                                    </GridItem3>

                                    <GridItem9
                                        align='center'
                                    >
                                        {formataPrimeiraReuniaoLabelValor(
                                            LABEL.patrimonioImobilizado,
                                                values.stepsValorPatrimonio[HARDCODE.indexPatrimonioPatrimonioImobilizado])
                                        }
                                    </GridItem9>
                                </GridContainer>
                            </GridItem5xs10>

                            <GridItem1xs2>
                                <CustomizedDialogsPopupPatrimonioImobilizado
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    setRefresh={setRefresh}
                                    refresh={refresh}
                                />
                            </GridItem1xs2>

                            <GridItem5xs10>
                                <GridContainer>
                                    <GridItem3
                                        align='right'
                                    >
                                        <SvgIconRecursosFinanceiros
                                            fontSize='large'
                                        />
                                    </GridItem3>

                                    <GridItem9
                                        align='center'
                                    >
                                        {formataPrimeiraReuniaoLabelValor(
                                            LABEL.recursosFinanceiros,
                                                values.stepsValorPatrimonio[HARDCODE.indexPatrimonioRecursosFinanceiros] -
                                                    valorPremioAnualizadoVidaInteira)
                                        }
                                    </GridItem9>
                                </GridContainer>
                            </GridItem5xs10>

                            <GridItem1xs2>
                                <CustomizedDialogsPopupRecursosFinanceiros
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    //jsonConfiguracao={jsonConfiguracao}
                                    setRefresh={setRefresh}
                                    refresh={refresh}
                                />
                            </GridItem1xs2>
                        </GridContainer>

                        {estudo.current.ativos !== 0 && (
                            <GridContainer>
                                <GridItem6xs12
                                    className={isXsDownScreen ? 'mt-5' : 'mt-15'}
                                >
                                    <GridContainer>
                                        <GridItem12>
                                            <GestaoPatrimonialFormResumoPatrimonialTotalAtivos
                                                values={values}
                                                estudo={estudo}
                                                report={report}
                                                popup={popup}
                                                simulacaoFinanceira={true}
                                                analisePatrimonial={false}
                                            />
                                        </GridItem12>
                                        
                                        <GridItem12
                                            className='mt-22'
                                        >
                                            <GridContainer>
                                                <GridItem1/>

                                                {!existeTabelaEvolucaoValorResgate(values) && (
                                                    <GridItem1/>
                                                )}

                                                <GridItem8>
                                                    <CustomizedDialogsPopupSucessaoVitalicia
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        estudo={estudo}
                                                        vars={vars}
                                                    />
                                                </GridItem8>

                                                {existeTabelaEvolucaoValorResgate(values) &&
                                                vars.linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === 'S' && (
                                                    <GridItem1>
                                                        <CustomizedDialogsPopupParametrosGestaoPatrimonial
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                            handleSubmitAutomatico={handleSubmitAutomatico}
                                                        />
                                                    </GridItem1>
                                                )}
                                            </GridContainer>
                                        </GridItem12>
                                    </GridContainer>
                                </GridItem6xs12>

                                <GridItem6xs12
                                    className='mt-5'
                                    align={isXsDownScreen ? 'center' : 'left'}
                                >
                                    <div
                                        className='ml--10'
                                    >
                                        <AnalisePatrimonialPieChart
                                            estudo={estudo}
                                            report={report}
                                            simulacaoFinanceira={true}
                                            valorCSVidaInteira={calculaValorCSVidaInteira(values, false)}
                                            valorPremioAnualizadoVidaInteira={valorPremioAnualizadoVidaInteira}
                                        />
                                    </div>
                                </GridItem6xs12>
                            </GridContainer>
                        )}
                    </CardGridEntradaDadosHeaderBody>

                    <CardGridEntradaDadosHeaderBody
                        title={LABEL.aposentadoriaExpectativaVida}
                    >
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            <GridItem10xs11>
                                {!expandiu && (
                                    <AposentadoriaExpectativaVidaCliente
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />
                                )}
                            </GridItem10xs11>

                            <GridItem1>
                                <AposentadoriaExpectativaVidaClienteConjuge
                                    values={values}
                                    handleChange={handleChange}
                                    setExpandiu={setExpandiu}
                                />
                            </GridItem1>
                        </GridContainer>
                    </CardGridEntradaDadosHeaderBody>
                    
                    <CardGridEntradaDadosHeaderBody
                        title={LABEL.taxaJurosInflacao}
                    >
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            <GridItem2xs4>
                                <TaxaCDIAnual
                                    values={values}
                                    handleChange={handleChange}
                                /> 
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <RetornoCDI
                                    values={values}
                                    handleChange={handleChange}
                                /> 
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <TaxaJurosAnual
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <TaxaInflacaoAnual
                                    values={values}
                                    handleChange={handleChange}
                                />
                            </GridItem2xs4>

                            <GridItem2xs4>
                                <TaxaRetornoAnualReal
                                    values={values}
                                    handleChange={handleChange}
                                    label={LABEL.taxaRetornoRealAnual}
                                />
                            </GridItem2xs4>

                            <GridItem1>
                                <CustomizedDialogsPopup
                                    maxWidth="md"
                                    popupTitle={LABEL.taxaJurosInflacao}
                                    tooltipTitle={LABEL.expandir}
                                    PopupButton={IconButtonMaisInformacoes}
                                    popupButtonDestaque={false}
                                    popupComponent={
                                        <>
                                            <GridContainer>
                                                <GridItem4>
                                                    <TaxaCDIAnual
                                                        values={values}
                                                        handleChange={handleChange}
                                                    /> 
                                                </GridItem4>
                                                <GridItem4>
                                                    <RetornoCDI
                                                        values={values}
                                                        handleChange={handleChange}
                                                    /> 
                                                </GridItem4>
                                                <GridItem4>
                                                    <TaxaJurosAnual
                                                        values={values}
                                                        handleChange={handleChange}
                                                    /> 
                                                </GridItem4>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem4>
                                                    <TaxaInflacaoAnual
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem4>
                                                <GridItem4>
                                                    <TaxaRetornoAnualReal
                                                        values={values}
                                                        handleChange={handleChange}
                                                        label={LABEL.taxaRetornoAnualReal}
                                                    />
                                                </GridItem4>
                                            </GridContainer>

                                            <GridContainer>
                                                <GridItem4>
                                                    <TipoMomentoTributacaoIR
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem4>

                                                {(values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
                                                values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
                                                values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                                values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                    <GridItem4>
                                                        <PercIR
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                )}

                                                {(values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                                values.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                    <GridItem4>
                                                        <TempoMinimoEntreAportesResgatesCalculoIRAnos
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                )}
                                            </GridContainer>
                                        </>
                                    }
                                    open={setExpandiu}
                                    onClose={() => {
                                        values.idadesCliente[1] = values.idadeVaiAposentarCliente
                                        values.idadesCliente[2] = values.idadeExpectativaVidaCliente
                                    }}
                                    afterClose={setExpandiu}
                                />
                            </GridItem1>
                        </GridContainer>

                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1/>
                            )}

                            {/*
                            <GridItem2xs4
                                className="mt-4 font-medium"
                            >
                                {LABEL.retornoFinanceiro}
                            </GridItem2xs4>

                            <GridItem4xs6>
                                <RetornoFinanceiroRadioGroup
                                    name="tipoRetornoFinanceiro"
                                    value={values.tipoRetornoFinanceiro || ''}
                                    onChange={handleChange}
                                />
                            </GridItem4xs6>

                            <GridItem4xs6>
                                <GridContainer>
                                    {values.tipoRetornoFinanceiro === HARDCODE.tipoRetornoFinanceiroReal && (
                                        <>
                                            <GridItem12>
                                                <ExibirEvolucaoAporteMensalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>

                                            <GridItem12>
                                                <ExibirEvolucaoRetiradaMensalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>
                                        
                                            <GridItem12>
                                                <ExibirEvolucaoRecursosFinanceirosFinalInflacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem12>
                                        </>
                                    )}

                                    <GridItem12>
                                        <DiferenciarTaxasAposAposentadoria
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem12>
                                </GridContainer>
                            </GridItem4xs6>
                            */}

                            <GridItem5xs6>
                                <GridContainer>
                                    <GridItem12>
                                        <ExibirEvolucaoAporteMensalInflacao
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem12>

                                    <GridItem12>
                                        <ExibirEvolucaoRetiradaMensalInflacao
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem12>
                                </GridContainer>
                            </GridItem5xs6>

                            <GridItem5xs6>
                                <GridContainer>
                                    <GridItem12>
                                        <ExibirEvolucaoRecursosFinanceirosFinalInflacao
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem12>

                                    <GridItem12>
                                        <DiferenciarTaxasAposAposentadoria
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem12>
                                </GridContainer>
                            </GridItem5xs6>
                        </GridContainer>

                        {values.diferenciarTaxasAposAposentadoria
                            ?
                                <>
                                    <GridContainer>
                                        {!isXsDownScreen && (
                                            <GridItem1/>
                                        )}

                                        <GridItem2xs4>
                                            <TaxaCDIAnualAposAposentadoria
                                                values={values}
                                                handleChange={handleChange}
                                            /> 
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            <RetornoCDIAposAposentadoria
                                                values={values}
                                                handleChange={handleChange}
                                            /> 
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            <TaxaJurosAnualAposAposentadoria
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            <TaxaInflacaoAnualAposAposentadoria
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            <TaxaRetornoAnualRealAposAposentadoria
                                                values={values}
                                                handleChange={handleChange}
                                                label={LABEL.taxaRetornoRealAnual}
                                            />
                                        </GridItem2xs4>
                                    </GridContainer>
                                </>
                            :
                                ''
                        }
                    </CardGridEntradaDadosHeaderBody>

                    <CardGridEntradaDadosHeaderBody
                        title={LABEL.capacidadePoupanca}
                    >
                        <GridContainer>
                            <GridItem5xs10>
                                <GridContainer>
                                    <GridItem3
                                        align='right'
                                    >
                                        <SvgIconReceitaMensal
                                            fontSize='large'
                                        />
                                    </GridItem3>

                                    <GridItem9
                                        align='center'
                                    >
                                        {formataPrimeiraReuniaoLabelValor(
                                            LABEL.receitaMensalMediaAtual, values.receitaMensalMediaAtual
                                                /*values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaReceitaMensal]*/)
                                        }
                                    </GridItem9>
                                </GridContainer>
                            </GridItem5xs10>

                            <GridItem1xs2>
                                <CustomizedDialogsPopupReceitaMensal
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    setRefresh={setRefresh}
                                    refresh={refresh}
                                />
                            </GridItem1xs2>

                            <GridItem5xs10>
                                <GridContainer>
                                    <GridItem3
                                        align='right'
                                    >
                                        <SvgIconDiaDia
                                            fontSize='large'
                                        />
                                    </GridItem3>

                                    <GridItem9
                                        align='center'
                                    >
                                        {formataPrimeiraReuniaoLabelValor(
                                            LABEL.despesaMensalMediaAtual, values.despesaMensalMediaAtual
                                                /*values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaDiaDia]*/)
                                        }
                                    </GridItem9>
                                </GridContainer>
                            </GridItem5xs10>

                            <GridItem1xs2>
                                <CustomizedDialogsPopupDespesas
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    handleSubmitAutomatico={handleSubmitAutomatico}
                                    vars={vars}
                                    //linhaTipoLicenca={vars.linhaTipoLicenca}
                                    //jsonConfiguracao={vars.jsonConfiguracao}
                                    //jsonUsuario={vars.jsonUsuario}
                                    //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                                    setRefresh={setRefresh}
                                    refresh={refresh}
                                />
                            </GridItem1xs2>
                        </GridContainer>

                        {(values.receitaMensalMediaAtual !== 0 || values.despesaMensalMediaAtual !== 0)
                        /*(values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaReceitaMensal] !== 0 ||
                        values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaDiaDia] !== 0)*/ && (
                            <GridContainer>
                                <GridItem6
                                    className='mt-7'
                                    align='right'
                                >
                                    <h6>
                                        {LABEL.capacidadePoupancaMensalMediaAtual + ' = ' +
                                            formataValor(values.capacidadePoupancaMensalMediaAtual
                                                /*values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaReceitaMensal]
                                                    - values.stepsValorFluxoCaixa[HARDCODE.indexFluxoCaixaDiaDia]*/, 2)}
                                    </h6>
                                </GridItem6>

                                <GridItem1
                                    className='mt-4'
                                >
                                    <CustomizedDialogsPopupCapacidadePoupanca
                                        variaveisGlobais={variaveisGlobais}
                                        values={values}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        estudo={estudo}
                                        vars={vars}
                                        setRefresh={setRefresh}
                                        refresh={refresh}
                                    />
                                </GridItem1>

                                <GridItem2>
                                    <GridContainer
                                        className='justify-center'
                                    >
                                        <GridItem9>
                                            <TextFieldNumberSelect
                                                name="percCapacidadePoupancaSugestaoAporteMensal"
                                                label={LABEL.percPoupanca}
                                                value={values.percCapacidadePoupancaSugestaoAporteMensal || ''}
                                                onChange={handleChange}
                                                list={percentualList}
                                            />
                                        </GridItem9>
                                    </GridContainer>
                                </GridItem2>

                                <GridItem3
                                    className='mt-7'
                                >
                                    <LinkPadraoNoSubmit
                                        title={
                                            <h6>
                                                {formataValor(round (values.capacidadePoupancaMensalMediaAtual *
                                                    values.percCapacidadePoupancaSugestaoAporteMensal / 100, 2), 2)}
                                            </h6>
                                        }
                                        tooltip={LABEL.cliqueParaAdicionarAutomaticamenteAporteMensal}
                                        onClick={() => {
                                            values.aporteMensalAntesAposentarCliente =
                                                round (values.capacidadePoupancaMensalMediaAtual *
                                                    values.percCapacidadePoupancaSugestaoAporteMensal / 100, 2)
                                        }}
                                    />
                                </GridItem3>
                            </GridContainer>
                        )}
                    </CardGridEntradaDadosHeaderBody>
                </CardGridEntradaDados>
            </GridItemParametros>
        )
    )
}

export default SimulacaoFinanceiraFormParametros